import { useEffect } from 'react'
import { normalizeLucaViewDescriptor } from '@containers/AIWidgetEmbed/pageContext'
import { useAIHelpContext, type LucaViewContext } from '@context'

/**
 * Publishes a page-owned Luca view descriptor into AIHelpContext so the
 * embedded widget can enrich page_context entity_* fields. Clears on unmount.
 */
export const useLucaViewContext = (descriptor: LucaViewContext | null) => {
  const { setViewContext } = useAIHelpContext()
  const entityType = descriptor?.entityType
  const entityId = descriptor?.entityId
  const entityLabel = descriptor?.entityLabel

  useEffect(() => {
    setViewContext(normalizeLucaViewDescriptor({ entityType, entityId, entityLabel }))

    return () => setViewContext(null)
  }, [entityType, entityId, entityLabel, setViewContext])
}
